import styled, { keyframes } from 'styled-components';

// PM Analitik Faz 2 Plan 3 (spec §6.5) — İK Operasyon Panosu yerleşimi: 12 kolon; KPI satırı (6) / 7+5 / 5+3+4 / 4+4+4.
// 1440 px altında KPI'lar üçlü, 1024 px altında iki kolon, 768 px altında tek kolon. Kart içinde kaydırma yok; renkler tema token'ı.
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const PageWrap = styled.div`
  padding: 0;
  min-height: 0;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 16px;
`;

export const Card = styled.section`
  background: ${({ theme }) => theme.colors.surface.card};
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(${({ theme }) => theme.colors.shadow.rgb}, 0.06);
  padding: ${({ $compact }) => ($compact ? '16px' : '20px')};
  grid-column: span ${({ $span }) => $span || 4};
  /* backwards: animasyon bitince transform kalmaz — kalırsa her kart ayrı katman bağlamı olur ve kart içindeki açılır listeler
     (GenericSelect, portalsız) sonraki kartların altında kalır (son inceleme, Önemli 2). */
  animation: ${fadeIn} 0.4s ease-out backwards;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;

  @media (max-width: 1440px) {
    grid-column: span ${({ $span, $kpi }) => ($kpi ? 4 : $span || 4)};
  }
  @media (max-width: 1024px) {
    grid-column: span 6;
  }
  @media (max-width: 768px) {
    grid-column: span 12;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 14px;
`;

export const CardTitle = styled.h3`
  font-size: ${({ theme }) => theme.metrics.font.size.md};
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const State = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex: 1;
  min-height: 120px;
  color: ${({ theme }) => theme.colors.text.muted};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  text-align: center;
`;

export const Skeleton = styled.div`
  flex: 1;
  min-height: 120px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.surface.border};
  opacity: 0.5;
`;

export const Badge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  background: ${({ theme }) => theme.colors.bgColor};
  color: ${({ theme, $tone }) => ($tone === 'danger' ? theme.colors.auxiliar.danger
    : $tone === 'success' ? theme.colors.secondary.dark
      : $tone === 'info' ? theme.colors.primary.main : theme.colors.text.primary)};
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  white-space: nowrap;
`;

export const KpiValue = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xxl};
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 1.1;
`;

export const KpiSub = styled.div`
  margin-top: 4px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const Trend = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 10px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  color: ${({ theme, $tone }) => ($tone === 'good' ? theme.colors.secondary.dark
    : $tone === 'bad' ? theme.colors.auxiliar.danger : theme.colors.text.muted)};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.primary};
  table-layout: fixed;

  th {
    text-align: left;
    font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
    color: ${({ theme }) => theme.colors.text.muted};
    font-size: ${({ theme }) => theme.metrics.font.size.xs};
    padding: 6px 6px 8px 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.surface.border};
  }
  td {
    padding: 8px 6px 8px 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.surface.border};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
  tr:last-child td { border-bottom: none; }
`;

export const Clickable = styled.button`
  all: unset;
  cursor: pointer;
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.colors.primary.main}; outline-offset: 2px; }
`;

export const Sub = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ProgressTrack = styled.div`
  flex: 1;
  height: 8px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.surface.border};
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  height: 100%;
  width: ${({ $pct }) => Math.max(0, Math.min(100, $pct || 0))}%;
  background: ${({ theme }) => theme.colors.primary.main};
`;

export const Tabs = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 12px;
  flex-wrap: wrap;
`;

export const TabButton = styled.button`
  all: unset;
  cursor: pointer;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  color: ${({ theme, $active }) => ($active ? theme.colors.surface.card : theme.colors.text.primary)};
  background: ${({ theme, $active }) => ($active ? theme.colors.primary.main : theme.colors.bgColor)};
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
`;

export const PageEmpty = styled.div`
  background: ${({ theme }) => theme.colors.surface.card};
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  border-radius: 10px;
  padding: 40px 24px;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.muted};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
`;
